import React from "react";
import { Link } from "react-router-dom";
import { Popover } from "@ebscois/react-component-library";
import { TooltipWrapper, StyledAnchor, MobileTooltipTrigger } from "./_.styled";

const ContentToolTip = ({
  triggerText,
  processContentPage,
  content,
  referenceId,
  isMobileDevice,
  isTabletDevice,
}) => {
  const touchDevice = isMobileDevice || isTabletDevice;
  return touchDevice ? (
    <Popover
      placement="top"
      trigger={
        <MobileTooltipTrigger kind="anchor">{triggerText}</MobileTooltipTrigger>
      }
      toggle="click"
      popperComponentProps={{
        variant: "primary",
      }}
      data-testid="reference-tooltip-mobile"
    >
      <TooltipWrapper
        preProcessors={[processContentPage()]}
        children={content}
      />
    </Popover>
  ) : (
    <Popover
      placement="top"
      trigger={
        <StyledAnchor
          linkComponent={Link}
          fontSize="xs"
          href={`#${referenceId}`}
        >
          {triggerText}
        </StyledAnchor>
      }
      toggle="hover"
      popperComponentProps={{
        variant: "primary",
      }}
      data-testid="reference-tooltip"
    >
      <TooltipWrapper
        preProcessors={[processContentPage()]}
        children={content}
      />
    </Popover>
  );
};

ContentToolTip.displayName = "ContentToolTip";

export default ContentToolTip;
